/** @format */

import Header from "../../components/home/header/header";
import Giftcard from "../../assets/images/Smart house security.png";
import SubmitButton from "../../components/atoms/submitbutton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { passwordRecoverySchema } from "../../validations/recovery";
import { MainSection, ImageSection, RecoverSection, Input } from "./styles";

type FormData = yup.InferType<typeof passwordRecoverySchema>;
const Recover = () => {
  const [isloading] = useState(false);

  const { register, handleSubmit, formState } = useForm<FormData>({
    resolver: yupResolver(passwordRecoverySchema),
  });
  const { errors } = formState;

  const recoveryRequest = (data: any) => {};

  return (
    <>
      <Header />
      <MainSection>
        <ImageSection>
          <img src={Giftcard} alt="" />
        </ImageSection>
        <RecoverSection>
          <form onSubmit={handleSubmit(recoveryRequest)}>
            <h2 className="mb-5">Recover Password</h2>
            <Input
              autoComplete="email"
              {...register("email")}
              type="email"
              placeholder="Email"
              name="email"
              width="312px"
            />

            {errors?.email && (
              <p className="text-xs mb-2 text-red-600">
                {errors.email?.message}
              </p>
            )}

            <SubmitButton
              value={"Send Recovery Link"}
              isloading={isloading}
              width="19.6em"
            />
          </form>
        </RecoverSection>
      </MainSection>
    </>
  );
};

export default Recover;
